import { Button, DownloadSVG, PlusSVG } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";

import AIButton from "@/components/AIComponents/AiButton";
import { useExportablesModalContext } from "@/components/AIComponents/ExportablesModal/ExportablesModalContext/useExportablesModalContext";
import {
  buttonContainerStyles,
  footerButtonWrapperCss,
  warningTextCss,
} from "./ExportablesModalFooter.styles";
import { getDownloadHandler } from "./utils";

const ButtonWithTrackEvent = withTrackEvent(Button);
const AIButtonWithTrackEvent = withTrackEvent(AIButton);

const TeacherActions = () => {
  const {
    formData,
    isInAssignGraphicOrganizersExperiment,
    selectedExportable,
    setShowAssignmentWarning,
    templatesToAssign,
  } = useExportablesModalContext();

  const label = selectedExportable.label || selectedExportable.title;
  const exportableLabel =
    label?.toLowerCase().replace(/\s+/g, "-") || "exportable";
  const downloadButtonQaSelector = `download-${exportableLabel}-pdf`;
  const addToAssignmentButtonQaSelector = `add-to-assignment-${exportableLabel}`;

  const handleAddToAssignment = () => {
    setShowAssignmentWarning(templatesToAssign.length === 0);
  };

  const handleDownload = getDownloadHandler({
    formData: formData?.[selectedExportable.seti_identifier],
    selectedExportable,
  });

  const downloadButtonProps = {
    flavor: Button.flavors.secondary,
    onClick: handleDownload,
    icon: {
      SvgComponent: DownloadSVG,
      alignment: Button.iconAlignments.right,
    },
    dataProps: { "data-qa-selector": downloadButtonQaSelector },
    objectType: objectTypes.generatedTextAsset,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.download,
    streamProperties: {
      description: "Download exportable PDF",
    },
  };

  return (
    <>
      <p css={warningTextCss} data-qa-selector="ai-warning-text">
        AI can make mistakes. Be sure to check AI-generated content before
        using.
      </p>
      {isInAssignGraphicOrganizersExperiment ? (
        <div css={footerButtonWrapperCss}>
          <ButtonWithTrackEvent {...downloadButtonProps}>
            Download as a PDF
          </ButtonWithTrackEvent>
          <AIButtonWithTrackEvent
            onClick={handleAddToAssignment}
            icon={{ SvgComponent: PlusSVG }}
            dataProps={{ "data-qa-selector": addToAssignmentButtonQaSelector }}
            objectType={objectTypes.generatedTextAsset}
            actionPrefix={actionPrefixes.initiate}
            actionName={actionNames.add}
            streamProperties={{
              description: `Add ${label.toLowerCase()} exportable to assignment`,
            }}
          >
            Add to assignment ({templatesToAssign.length})
          </AIButtonWithTrackEvent>
        </div>
      ) : (
        <AIButtonWithTrackEvent
          {...downloadButtonProps}
          __cssFor={buttonContainerStyles}
        >
          Download as a PDF
        </AIButtonWithTrackEvent>
      )}
    </>
  );
};

export default TeacherActions;
